import React, { useContext, useState } from 'react'
import './PlaceOrder.css'
import { StoreContext } from '../../context/StoreContex';
import axios from 'axios';
 
const PlaceOrder = () => {
  const { totalAmount} = useContext(StoreContext);
  
  
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    phone: "",
    paymentMethod: "",
  });

  const paymentDetails = {
    payType: "cash",
    amount: parseFloat(totalAmount),
    change: parseFloat(0),
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Simple validation
    if (!formData.paymentMethod) {
      alert("Select Paymnet Method");
      return;
    }

    if(formData.paymentMethod=='cashOnDelivery'){
      try {
        // const response = await axios.post(backendUrl + '/addPayment', { cart: cartData }, { headers: { Authorization: "Bearer " + token } });
        //  const amountTotal = await response.data.data.total;
        //  const numberOrder = await response.data.data.orderNo;
        // setTotalAmount(amountTotal);
        // setOrderNumber(numberOrder);
    } catch (error) {
        console.error("Error sending cart data:", error);
    }
    }
  };


  return (
    <form className='place-order' onSubmit={handleSubmit}>
      <div className="place-order-left">
         <p className='title'>Delivery Information</p>
         <div className="multi-fields">
          <input type="text" name="firstName" placeholder='First Name' required onChange={handleChange} />
          <input type="text" name="lastName" placeholder='Last Name' required onChange={handleChange} />
         </div>
         <input type="text" name="email" placeholder='Email address' required onChange={handleChange} />
         <input type="text" name="street" placeholder='Street' required onChange={handleChange}/>
         <div className="multi-fields">
          <input type="text" name="city" placeholder='City' required onChange={handleChange} />
          <input type="text" name="state" placeholder='State' required onChange={handleChange} />
         </div>
         <div className="multi-fields"> 
          <input type="text" name="zip" placeholder='Zip code' required onChange={handleChange} />
          <input type="text" name="country" placeholder='Country' required onChange={handleChange} />
         </div>
         <input type="text" name="phone" placeholder='Phone' required onChange={handleChange} />
         <p className='title'>Payment Method</p>
        <div className='payment-options'>
          <label>
            <input type="radio" name="paymentMethod" value="creditCard" checked={formData.paymentMethod === "creditCard"} onChange={handleChange} /> Credit Card
          </label>
          <label>
            <input type="radio" name="paymentMethod" value="paypal" checked={formData.paymentMethod === "paypal"} onChange={handleChange} /> PayPal
          </label>
          <label>
            <input type="radio" name="paymentMethod" value="cashOnDelivery" checked={formData.paymentMethod === "cashOnDelivery"} onChange={handleChange} /> Cash on Delivery
          </label>
        </div>

      </div>
      <div className="place-order-right">
      <div className='cart-total'>
           <h2>Cart Total</h2>
           <div>
           <div className="cart-total-details">
            <p>Subtotal</p>
            <p>${totalAmount.toFixed(2)}</p>
            </div>
            <hr />
            <div className="cart-total-details">
              <p>Delivery Fee</p>
              <p>${(totalAmount===0?0:2).toFixed(2)}</p>
            </div>
            <hr />
            <div className="cart-total-details">
              <b>Total</b>
              <b>${(totalAmount===0?0:totalAmount+2).toFixed(2)}</b>
            </div>
           </div>
           <button>Proceed To Payment</button>
        </div>
      </div>
    </form>
  )
}

export default PlaceOrder